import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import styled from "@mui/material/styles/styled";

import { neutral } from "app/themes/colors";

export const ReportTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    overflow: "hidden",
    pl: 1.5,
    fontWeight: 700,
    color: "black",
    whiteSpace: "normal",
    lineHeight: "normal",
    textTransform: "uppercase",
    letterSpacing: 0.7,
    fontSize: "12px",
    background: neutral[100]
  },
  [`&.${tableCellClasses.sizeMedium}`]: {
    fontSize: "14px",
    "@media (max-width:1700px)": {
      fontSize: "13px"
    }
  }
}));
